/** @file A titled list of warnings (code, English server message, path), cut to a maximum with a count. */
import type { Warning } from '@pose2d/format/types';
import type { Translate } from '@pose2d/i18n/types';

/** Props of WarningList; `title` is already translated. */
export interface WarningListProps {
  t: Translate;
  title: string;
  warnings: readonly Warning[];
  max: number;
}

/** Renders nothing for no warnings; INFO notes and real warnings get their own class. */
export function WarningList({ t, title, warnings, max }: WarningListProps) {
  if (warnings.length === 0) return null;
  return (
    <section className="warning-list" aria-label={title}>
      <h4>{title}</h4>
      <ul>
        {warnings.slice(0, max).map((w, i) => (
          <li key={i} className={w.code === 'INFO' ? 'warning-info' : 'warning-warn'}>
            <code>{w.code}</code> {w.message}
            {w.path === undefined ? null : <span className="warning-path">{w.path}</span>}
          </li>
        ))}
      </ul>
      {warnings.length > max ? <p className="warning-more">{t('psdImport.more', { n: warnings.length - max })}</p> : null}
    </section>
  );
}
